/** Small progressive enhancement; content, navigation and pricing work without JS. */
const stage = document.querySelector<HTMLElement>('.flow-stage');
if (stage) {
  const status = stage.querySelector<HTMLElement>('[data-demo-status]');
  const description = stage.querySelector<HTMLElement>('[data-rule-description]');
  const label = stage.querySelector<HTMLElement>('[data-rule-label]');
  const copy = stage.querySelector<HTMLElement>('[data-copy]');
  const filtered = stage.querySelector<HTMLElement>('[data-filtered]');
  const samples = {
    replace: {
      label: 'Make it yours',
      description: 'Harbor → Matchroom',
      html: '<p><strong>Matchroom</strong> match update</p><p>162/4 · 18.2 overs</p><p>⚡ Every ball counts.</p><span class="sample-link block [color:#4d7760] text-[11px] mt-[9px]">t.me/harbor</span>'
    },
    format: {
      label: 'Keep the emphasis',
      description: 'Source formatting, preserved',
      html: '<p><strong>Harbor</strong> match update</p><p><em class="[color:inherit]! italic!">Every ball counts.</em></p><p><code>162/4 · 18.2 overs</code></p>'
    },
    filter: {
      label: 'Only the right posts',
      description: 'Required keyword “FINAL” is absent',
      html: ''
    }
  };
  stage.querySelectorAll<HTMLButtonElement>('[data-mode-button]').forEach((button) =>
    button.addEventListener('click', () => {
      stage.dataset.mode = button.dataset.modeButton;
      stage
        .querySelectorAll<HTMLButtonElement>('[data-mode-button]')
        .forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      const caption = stage.querySelector<HTMLElement>('[data-source-caption]');
      if (caption)
        caption.textContent =
          stage.dataset.mode === 'hybrid'
            ? 'The service reader listens to this source.'
            : 'The selected bot reads the source.';
      if (status)
        status.textContent = `${stage.dataset.mode} mode, ${stage.dataset.example} example.`;
    })
  );
  stage.querySelectorAll<HTMLButtonElement>('[data-example-button]').forEach((button) =>
    button.addEventListener('click', () => {
      const example = button.dataset.exampleButton as keyof typeof samples;
      if (!samples[example]) return;
      stage.dataset.example = example;
      stage
        .querySelectorAll<HTMLButtonElement>('[data-example-button]')
        .forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      if (label) label.textContent = samples[example].label;
      if (description) description.textContent = samples[example].description;
      if (copy) {
        copy.hidden = example === 'filter';
        copy.innerHTML = samples[example].html;
      }
      if (filtered) filtered.hidden = example !== 'filter';
      if (status) status.textContent = `${stage.dataset.mode} mode, ${example} example.`;
    })
  );
  const page = document.querySelector<HTMLElement>('.marketing-page');
  const pauses = document.querySelectorAll<HTMLButtonElement>('[data-pause]');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const setPaused = (value: boolean) => {
    stage.dataset.paused = String(value);
    if (page) page.dataset.motionPaused = String(value);
    pauses.forEach((button) => {
      button.setAttribute('aria-pressed', String(value));
      button.textContent = value ? 'Play motion' : 'Pause motion';
    });
  };
  setPaused(reduced.matches);
  reduced.addEventListener('change', () => setPaused(reduced.matches));
  pauses.forEach((button) =>
    button.addEventListener('click', () => setPaused(stage.dataset.paused !== 'true'))
  );
  const scene = document.querySelector<HTMLElement>('.gem-universe');
  const spin = scene?.querySelector<HTMLButtonElement>('[data-gem-spin]');
  const spinStatus = scene?.querySelector<HTMLElement>('[data-gem-status]');
  spin?.addEventListener('click', () => {
    if (reduced.matches) {
      if (spinStatus)
        spinStatus.textContent = 'Motion is off to respect your reduced-motion preference.';
      return;
    }
    setPaused(false);
    spin.disabled = true;
    if (scene) scene.dataset.spinning = 'true';
    if (spinStatus) spinStatus.textContent = 'Playing the gem illustration. No messages are sent.';
  });
  const finishSpin = (event: AnimationEvent) => {
    if (event.animationName !== 'gem-spin') return;
    if (scene) scene.dataset.spinning = 'false';
    if (spin) spin.disabled = false;
  };
  scene?.addEventListener('animationend', finishSpin);
  scene?.addEventListener('animationcancel', finishSpin);
  stage.querySelector('[data-replay]')?.addEventListener('click', () => {
    if (reduced.matches) return;
    (page ?? stage).getAnimations({ subtree: true }).forEach((animation) => {
      animation.currentTime = 0;
    });
    setPaused(false);
  });
}
